module.exports = __webpack_public_path__ + "img/Bingo_Info_Game2.eb320daf.png";